import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const AssignedRadialBar = ({ dataColors }) => {
  const chartColors = getChartColorsArray(dataColors);
  const series = [70];

  const options = {
    chart: {
      height: 300,
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "65%",
        },
        dataLabels: {
          name: {
            fontSize: "18px",
            offsetY: -10,
            show: true,
          },
          value: {
            fontSize: "20px",
            offsetY: 5,
            show: true,
          },
        },
      },
    },
    labels: ["Assigned"],
    colors: chartColors,
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title mb-3">Assignment</h5>
        <ReactApexChart
          dir="ltr"
          className="apex-charts"
          series={series}
          options={options}
          type="radialBar"
          height={300}
        />
      </div>
    </div>
  );
};

export default AssignedRadialBar;
